// extracted by mini-css-extract-plugin
export var aboveInput = "_f3-0";
export var actionButton = "_f3-5";
export var actionButtonContainer = "_f3-1";
export var actionIcon = "_f3-6";
export var aiInfoContainer = "_f3-2";
export var attachmentWrapper = "_f3-7";
export var bold = "_f3-3";
export var checkIcon = "_f3-8";
export var clickingRecipientBar = "_f3-11";
export var commentThreadSwitch = "_f3-a";
export var draftImage = "_f3-b";
export var draftImageContainer = "_f3-c";
export var draftImages = "_f3-e";
export var editButton = "_f3-g";
export var editor = "_f3-f";
export var editorContainer = "_f3-y";
export var editorErrorTooltipWrapper = "_f3-9";
export var headerDivider = "_f3-h";
export var icon = "_f3-i";
export var info = "_f3-j";
export var internal = "_f3-n";
export var internalDivider = "_f3-k";
export var internalMessage = "_f3-l";
export var messageInputCard = "_f3-m";
export var messageInputForm = "_f3-o";
export var messageInputFormInternal = "_f3-p";
export var options = "_f3-q";
export var publicMessageCustomer = "_f3-s";
export var publicMessageMerchant = "_f3-r";
export var removeImageButton = "_f3-d";
export var replyButtons = "_f3-t";
export var showSignatureButton = "_f3-u";
export var spinner = "_f3-v";
export var verticalButtonDivider = "_f3-4";
export var visibilitySelector = "_f3-w";
export var warning = "_f3-x";
export var wrappingText = "_f3-z";
export var writingInternalNoteTopBorder = "_f3-10";